import React from "react";

import NavbarBottom from "../NavbarBottom";

import Module2PDFGenerator from "./Module2PDFGenerator";

import Page1 from "./Pages/Page1";
import Page2 from "./Pages/Page2";
import Page3 from "./Pages/Page3";
import Page4 from "./Pages/Page4";
import Page5 from "./Pages/Page5";

import { module2_visits } from "../../firebase";

class Module2 extends React.Component {
  state = {
    pageNum: 1,
    maxPageNum: 5,

    pdfInfo_Age: "",
    pdfInfo_Answer: "",
  };

  componentDidMount() {
    for (var i = 0; i < this.inputRefs.length; i++) {
      this.inputRefs[i].checkPageVisibility(this.state.pageNum);
    }
    this.incNumModuleVisits();
    window.addEventListener("beforeunload", (event) => {
      event.returnValue = "Are you sure you want to leave?";
    });
  }

  incNumModuleVisits = async () => {
    try {
      const visits = await module2_visits.get();
      let moduleFirebaseID = "";
      let currentNumVisits = 0;

      visits.forEach((numVisits) => {
        currentNumVisits = numVisits.data().visits;
        moduleFirebaseID = numVisits.id;
      });

      const moduleVisits = await module2_visits.doc(moduleFirebaseID);
      moduleVisits.update({ visits: currentNumVisits + 1 });
    } catch (error) {
      console.log("Error getting number of page visits", error);
    }
  };

  inputRefs = [];
  setRef = (ref) => {
    this.inputRefs.push(ref);
  };

  pdfGeneratorRef = null;
  setRefPDFGenerator = (ref) => {
    this.pdfGeneratorRef = ref;
  };

  moveForward = () => {
    let page = this.state.pageNum;
    page = page < this.state.maxPageNum ? page + 1 : page;
    this.setPage(page);
  };

  moveBackward = () => {
    let page = this.state.pageNum;
    page = page > 1 ? page - 1 : page;
    this.setPage(page);
  };

  setPage = (page) => {
    this.setState({
      pageNum: page,
    });
    for (var i = 0; i < this.inputRefs.length; i++) {
      this.inputRefs[i].checkPageVisibility(page);
    }
  };

  setPdfInfo_Age = (answer) => {
    if (answer != null) this.setState({ pdfInfo_Age: answer });
  };

  setPdfInfo_Answer = (answer) => {
    if (answer != null) this.setState({ pdfInfo_Answer: answer });
  };

  jsPdfGenerator = () => {
    this.pdfGeneratorRef.genertatePDF(
      this.state.pdfInfo_Age,
      this.state.pdfInfo_Answer
    );
  };

  render() {
    return (
      <div style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <Page1 ref={this.setRef} />
        <Page2 ref={this.setRef} updatePdf={this.setPdfInfo_Age} />
        <Page3 ref={this.setRef} />
        <Page4 ref={this.setRef} updatePdf={this.setPdfInfo_Answer} />
        <Page5 ref={this.setRef} />

        <Module2PDFGenerator ref={this.setRefPDFGenerator} />

        <NavbarBottom
          moveForwardHandler={this.moveForward}
          moveBackwardHandler={this.moveBackward}
          title="I have some ideas and want to focus my thinking"
        >
          <div className="dropdown-item" onClick={() => this.setPage(1)}>
            Introduction
          </div>
          <div className="dropdown-item" onClick={() => this.setPage(2)}>
            Quiz
          </div>
          <div className="dropdown-item" onClick={() => this.setPage(3)}>
            Tips to narrow your thinking
          </div>
          <div className="dropdown-item" onClick={() => this.setPage(4)}>
            Decision making model
          </div>
          <div className="dropdown-item" onClick={() => this.setPage(5)}>
            Learning Points
          </div>
          <hr />
          <div className="dropdown-item" onClick={() => this.jsPdfGenerator()}>
            Download as PDF
          </div>
        </NavbarBottom>
      </div>
    );
  }
}

export default Module2;
